var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDlagastronomiiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.87 53.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.58,36.28l-1.77-3.54-1.77,3.54h-2.65l2.57,2.04-.8,3.27,2.65-1.77,2.65,1.77-.8-3.27,2.57-2.04h-2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.82,36.28l-1.77-3.54-1.77,3.54h-2.65l2.57,2.04-.8,3.27,2.65-1.77,2.65,1.77-.8-3.27,2.57-2.04h-2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.2,32.74l-1.77-3.54-1.77,3.54h-2.65l2.57,2.04-.8,3.27,2.65-1.77,2.65,1.77-.8-3.27,2.57-2.04h-2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.01,51.63c.45.91,1.36,1.47,2.37,1.47h38.1c1.01,0,1.92-.56,2.37-1.47l1.04-2.07H4.97l1.04,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.77,46.02h51.33v1.77H1.77v-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.97,5.31c0-.49-.4-.88-.88-.88h-5.31c-.49,0-.88.4-.88.88v.88h7.08v-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.81,28.79l1.09,2.19h6.66l2.86-5.73,2.86,5.73h6.66l1.09-2.19v-.47h1.77v1.77h-1.12l1.33,2.65h1.56v-7.08c0-7.81-6.35-14.16-14.16-14.16s-14.16,6.35-14.16,14.16v7.08h1.56l1.98-3.96ZM34.03,15.18c3.63,2.29,5.79,6.21,5.79,10.48v.88h-1.77v-.88c0-3.66-1.86-7.02-4.97-8.99l.95-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.43,9.73c.6,0,1.19.04,1.77.1v-1.87h-3.54v1.87c.58-.06,1.17-.1,1.77-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.38,15.14l-.72,23.8c0,1.95,1.59,3.54,3.54,3.54s3.54-1.59,3.54-3.57l-.69-23.78c2.06-1.22,3.34-3.63,3.34-6.28C12.39,4.84,9.63,0,6.19,0S0,4.84,0,8.85c0,2.65,1.28,5.06,3.38,6.29h0ZM6.19,4.42c.6,0,1.77,2.39,1.77,4.42,0,1.46-.79,2.65-1.77,2.65s-1.77-1.19-1.77-2.65c0-2.04,1.17-4.42,1.77-4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.1,0v7.08h-1.77V0h-1.77v7.08h-1.77V0h-1.77v7.08h-1.77V0h-1.77v9.99c0,2.36,1.31,4.48,3.42,5.54l.09.05-.86,23.36c0,1.95,1.59,3.54,3.54,3.54s3.54-1.59,3.54-3.57l-.86-23.32.09-.05c2.11-1.06,3.42-3.18,3.42-5.54V0h-1.77Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlagastronomiiIcon);
export default __webpack_public_path__ + "static/media/Dla gastronomii_icon.201350579678ce7ebd958419a075cf7c.svg";
export { ForwardRef as ReactComponent };